import React, { useState } from "react";
import Nav from "../Nav";
import emailjs from "emailjs-com";
import {
  Container,
  Typography,
  Box,
  Button,
  Grid,
  TextField,
} from "@mui/material";
import "./contact.css";

const Contact = () => {
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    country: "",
    telephone: "",
    email: "",
    skypeId: "",
    message: "",
  });

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    emailjs
      .send(
        "service_bqxwz3b",
        "template_fta434i",
        formData,
        "QgmIaU9nW5RoQLZ2x"
      )
      .then((response) => {
        console.log("SUCCESS!", response.status, response.text);
        // Reset form or show success message
        setFormData({
          firstName: "",
          lastName: "",
          country: "",
          telephone: "",
          email: "",
          skypeId: "",
          message: "",
        });
      })
      .catch((err) => {
        console.error("FAILED...", err);
        // Show error message
      });
  };

  return (
    <>
      <Nav />
      <Box
        sx={{
          backgroundColor: "#f8fafc",
          py: 5,
          fontFamily: "Arial, sans-serif",
        }}
      >
        <Box
          sx={{ py: 15, textAlign: "center", color: "#172b4d" }}
          style={{ backgroundColor: "#f8fafc" }}
        >
          <Container maxWidth="lg" style={{ backgroundColor: "#f8fafc" }}>
            <Typography
              variant="h2"
              align="center"
              className="merriweather-bold"
              gutterBottom
              sx={{ fontWeight: "bold" }}
            >
              Contact Us
            </Typography>
            <div id="image-container" className="absolute top-20 left-0">
              <img
                src="https://demo.edublink.co/wp-content/uploads/2023/05/shape-13.png"
                className="ml-4 mt-4"
                alt="Small Image"
              />
            </div>
            <div id="image-container2" className="absolute top-20 right-80">
              <img
                src="https://demo.edublink.co/wp-content/uploads/2023/07/shape-37.png"
                className="h-32 w-32"
                alt=""
              />
            </div>
            <div id="image-container3" className="absolute top-120 right-40">
              <img
                src="https://demo.edublink.co/wp-content/uploads/2023/05/shape-02.png"
                className="h-32 w-32"
                alt=""
              />
            </div>
            <div id="image-container3" className="absolute bottom-20 right-0">
              <img
                src="https://demo.edublink.co/wp-content/themes/edublink/assets/images/shapes/breadcrumb-shape-3.png"
                className="h-48 w-32"
                alt=""
              />
            </div>
          </Container>
        </Box>
        <Container
          maxWidth="lg"
          sx={{ backgroundColor: "#ffffff", p: 5, borderRadius: 2, mt: -8 }}
        >
          <Grid container spacing={4}>
            <Grid item xs={12} md={6}>
              <Box sx={{ backgroundColor: "#fff", p: 0, borderRadius: "8px" }}>
                <Typography
                  className="merriweather-regular"
                  variant="h4"
                  gutterBottom
                  sx={{ fontWeight: "bold" }}
                >
                  Have you got a question for us?
                </Typography>
                <Typography
                  className="merriweather-regular"
                  variant="h4"
                  gutterBottom
                  sx={{ fontWeight: "bold" }}
                >
                  We're Always Eager to Hear From You!
                </Typography>
                <Typography
                  className="merriweather-regular"
                  variant="body1"
                  gutterBottom
                  sx={{ lineHeight: "1.4" }}
                >
                  You wish to share your current challenges and would like to
                  know if some of my programs could push you in the right
                  direction.
                </Typography>
                <Typography
                  className="merriweather-regular"
                  variant="body1"
                  gutterBottom
                  sx={{ lineHeight: "1" }}
                >
                  Don’t be a stranger and get in touch!
                </Typography>
                <Typography
                  className="merriweather-regular"
                  variant="body1"
                  gutterBottom
                  style={{ marginTop: "20px" }}
                >
                  Address
                </Typography>
                <Typography
                  className="merriweather-regular"
                  variant="body1"
                  gutterBottom
                  sx={{ fontWeight: "bold", color: "#6b778c" }}
                >
                  30 N Gould St Ste N, Sheridan, WY,
                </Typography>
                <Typography
                  className="merriweather-regular"
                  variant="body1"
                  gutterBottom
                  sx={{ fontWeight: "bold", color: "#6b778c" }}
                >
                  82801, US
                </Typography>
                <Typography
                  className="merriweather-regular"
                  variant="body1"
                  gutterBottom
                  style={{ marginTop: "20px" }}
                >
                  Email
                </Typography>
                <Typography
                  className="merriweather-regular"
                  variant="body1"
                  gutterBottom
                  sx={{ fontWeight: "bold", color: "#6b778c" }}
                >
                  contact@radebjelan.com
                </Typography>
                <Box sx={{ mt: 2 }}>
                  <Button href="#" aria-label="Share">
                    <img
                      src="data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiA/PjxzdmcgaGVpZ2h0PSI1MTIiIHZpZXdCb3g9IjAgMCA1MTIgNTEyIiB3aWR0aD0iNTEyIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPjx0aXRsZS8+PGNpcmNsZSBjeD0iMTI4IiBjeT0iMjU2IiByPSI0OCIgc3R5bGU9ImZpbGw6bm9uZTtzdHJva2U6IzAwMDtzdHJva2UtbGluZWNhcDpyb3VuZDtzdHJva2UtbGluZWpvaW46cm91bmQ7c3Ryb2tlLXdpZHRoOjMycHgiLz48Y2lyY2xlIGN4PSIzODQiIGN5PSIxMTIiIHI9IjQ4IiBzdHlsZT0iZmlsbDpub25lO3N0cm9rZTojMDAwO3N0cm9rZS1saW5lY2FwOnJvdW5kO3N0cm9rZS1saW5lam9pbjpyb3VuZDtzdHJva2Utd2lkdGg6MzJweCIvPjxjaXJjbGUgY3g9IjM4NCIgY3k9IjQwMCIgcj0iNDgiIHN0eWxlPSJmaWxsOm5vbmU7c3Ryb2tlOiMwMDA7c3Ryb2tlLWxpbmVjYXA6cm91bmQ7c3Ryb2tlLWxpbmVqb2luOnJvdW5kO3N0cm9rZS13aWR0aDozMnB4Ii8+PGxpbmUgc3R5bGU9ImZpbGw6bm9uZTtzdHJva2U6IzAwMDtzdHJva2UtbGluZWNhcDpyb3VuZDtzdHJva2UtbGluZWpvaW46cm91bmQ7c3Ryb2tlLXdpZHRoOjMycHgiIHgxPSIxNjkuODMiIHgyPSIzNDIuMTciIHkxPSIyNzkuNTMiIHkyPSIzNzYuNDciLz48bGluZSBzdHlsZT0iZmlsbDpub25lO3N0cm9rZTojMDAwO3N0cm9rZS1saW5lY2FwOnJvdW5kO3N0cm9rZS1saW5lam9pbjpyb3VuZDtzdHJva2Utd2lkdGg6MzJweCIgeDE9IjM0Mi4xNyIgeDI9IjE2OS44MyIgeTE9IjEzNS41MyIgeTI9IjIzMi40NyIvPjwvc3ZnPg=="
                      width="24"
                      height="24"
                    />
                  </Button>
                  <Button href="#" aria-label="Share">
                    <img
                      src="data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiA/Pjxzdmcgdmlld0JveD0iMCAwIDI1NiAyNTYiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHJlY3QgZmlsbD0ibm9uZSIgaGVpZ2h0PSIyNTYiIHdpZHRoPSIyNTYiLz48Y2lyY2xlIGN4PSIxMjgiIGN5PSIxMjgiIGZpbGw9Im5vbmUiIHI9Ijk2IiBzdHJva2U9IiMwMDAiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIgc3Ryb2tlLXdpZHRoPSIxNiIvPjxwYXRoIGQ9Ik0xNjgsODhIMTUyYTIzLjksMjMuOSwwLDAsMC0yNCwyNFYyMjQiIGZpbGw9Im5vbmUiIHN0cm9rZT0iIzAwMCIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIiBzdHJva2Utd2lkdGg9IjE2Ii8+PGxpbmUgZmlsbD0ibm9uZSIgc3Ryb2tlPSIjMDAwIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiIHN0cm9rZS13aWR0aD0iMTYiIHgxPSI5NiIgeDI9IjE2MCIgeTE9IjE0NCIgeTI9IjE0NCIvPjwvc3ZnPg=="
                      width="24"
                      height="24"
                    />
                  </Button>
                  <Button href="#" aria-label="Share">
                    <img
                      src="data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiA/Pjxzdmcgdmlld0JveD0iMCAwIDI1NiAyNTYiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHJlY3QgZmlsbD0ibm9uZSIgaGVpZ2h0PSIyNTYiIHdpZHRoPSIyNTYiLz48Y2lyY2xlIGN4PSIxMjgiIGN5PSIxMjgiIGZpbGw9Im5vbmUiIHI9IjQwIiBzdHJva2U9IiMwMDAiIHN0cm9rZS1taXRlcmxpbWl0PSIxMCIgc3Ryb2tlLXdpZHRoPSIxNiIvPjxyZWN0IGZpbGw9Im5vbmUiIGhlaWdodD0iMTg0IiByeD0iNDgiIHN0cm9rZT0iIzAwMCIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIiBzdHJva2Utd2lkdGg9IjE2IiB3aWR0aD0iMTg0IiB4PSIzNiIgeT0iMzYiLz48Y2lyY2xlIGN4PSIxODAiIGN5PSI3NiIgcj0iMTIiLz48L3N2Zz4="
                      width="24"
                      height="24"
                    />
                  </Button>
                </Box>
              </Box>
            </Grid>

            <Grid item xs={12} md={6}>
              <Box
                sx={{
                  backgroundColor: "#fff",
                  p: 3,
                  borderRadius: "4px",
                  boxShadow: "0 0 15px rgba(0, 0, 0, 0.1)",
                }}
              >
                <Typography
                  className="merriweather-regular"
                  variant="h4"
                  gutterBottom
                  sx={{ fontWeight: "bold" }}
                >
                  Get In Touch
                </Typography>
                <form onSubmit={handleSubmit}>
                  <Box sx={{ mb: 3 }}>
                    <TextField
                      fullWidth
                      label="First name"
                      variant="outlined"
                      required
                      name="firstName"
                      value={formData.firstName}
                      onChange={handleChange}
                    />
                  </Box>
                  <Box sx={{ mb: 3 }}>
                    <TextField
                      fullWidth
                      label="Last name"
                      variant="outlined"
                      required
                      name="lastName"
                      value={formData.lastName}
                      onChange={handleChange}
                    />
                  </Box>
                  <Box sx={{ mb: 3 }}>
                    <TextField
                      fullWidth
                      label="Country"
                      variant="outlined"
                      required
                      name="country"
                      value={formData.country}
                      onChange={handleChange}
                    />
                  </Box>
                  <Box sx={{ mb: 3 }}>
                    <TextField
                      fullWidth
                      label="Telephone No"
                      variant="outlined"
                      required
                      name="telephone"
                      value={formData.telephone}
                      onChange={handleChange}
                    />
                  </Box>
                  <Box sx={{ mb: 3 }}>
                    <TextField
                      fullWidth
                      label="Enter your email"
                      variant="outlined"
                      type="email"
                      required
                      name="email"
                      value={formData.email}
                      onChange={handleChange}
                    />
                  </Box>
                  <Box sx={{ mb: 3 }}>
                    <TextField
                      fullWidth
                      label="Skype Id"
                      variant="outlined"
                      name="skypeId"
                      value={formData.skypeId}
                      onChange={handleChange}
                    />
                  </Box>
                  <Box sx={{ mb: 3 }}>
                    <TextField
                      fullWidth
                      label="Your Message"
                      variant="outlined"
                      multiline
                      rows={4}
                      required
                      name="message"
                      value={formData.message}
                      onChange={handleChange}
                    />
                  </Box>
                  <Button
                    className="merriweather-regular"
                    type="submit"
                    variant="contained"
                    style={{ backgroundColor: "rgb(26, 182, 157)" }}
                  >
                    Submit Message
                  </Button>
                </form>
              </Box>
            </Grid>
          </Grid>
        </Container>
      </Box>
    </>
  );
};

export default Contact;
